var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPaymentStatusFailed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 51,
  height: 50,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25.5,
  cy: 25,
  r: 25,
  fill: "#FFE4E7"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 12,
  fill: "#FF586D"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m30 21.37-.87-.87L25 24.63l-4.13-4.13-.87.87 4.13 4.13L20 29.63l.87.87L25 26.37l4.13 4.13.87-.87-4.13-4.13z"
})));
export default SvgIconPaymentStatusFailed;